const initialState = {
  data: null,
};

const homeHeroReducer = (state = initialState) => {
  return state; // SSR-only, no updates needed
};

export default homeHeroReducer;
